<div class="db-no-data-info" [ngClass]="small ? 'small' : null">
  <div class="message">
    @if ( i18nMessageKey ) {
      {{ i18n?.i18nLng()[i18nMessageKey] }}
    } @else {
      {{ message }}
    }
  </div>
</div>
